module.exports = __webpack_public_path__ + "img/1728877686591-WhatsApp Image 2024-10-14 at 11.47.48.jpeg.8c53ff91.webp";